import { render, staticRenderFns } from "./ResponsiveImage.vue?vue&type=template&id=246a5602&scoped=true"
import script from "./ResponsiveImage.vue?vue&type=script&lang=js"
export * from "./ResponsiveImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246a5602",
  null
  
)

export default component.exports